import React from 'react';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';

import type {SwiperOptions} from 'swiper/types';
// eslint-disable-next-line import/no-duplicates
import 'swiper/css';
// eslint-disable-next-line import/no-duplicates
import 'swiper/css/navigation';
// eslint-disable-next-line import/no-duplicates
import 'swiper/css/pagination';

type Props = {
  children: React.ReactNode[];
  slidesPerView?: number | 'auto';
  spaceBetween?: number;
  loop?: boolean;
  autoplay?: boolean;
  centeredSlides?: boolean;
  overflowVisible?: boolean;
  breakpoints?: SwiperOptions['breakpoints'];
};

export const SwiperCarousel: React.FC<Props> = ({
  children,
  slidesPerView = 'auto',
  spaceBetween = 16,
  loop = false,
  autoplay = false,
  centeredSlides = false,
  overflowVisible = false,
  breakpoints,
}) => (
  <Swiper
    modules={[Navigation, Pagination, ...(autoplay ? [Autoplay] : [])]}
    slidesPerView={slidesPerView}
    spaceBetween={spaceBetween}
    loop={loop}
    autoplay={autoplay ? {delay: 4000, disableOnInteraction: false} : false}
    centeredSlides={centeredSlides}
    breakpoints={breakpoints}
    navigation
    pagination={{clickable: true}}
    className={`w-full !pb-10${overflowVisible ? ' !overflow-visible' : ''}`}>
    {React.Children.map(children, (child, i) => (
      <SwiperSlide
        key={i}
        className={slidesPerView === 'auto' ? '!w-72' : undefined}>
        {child}
      </SwiperSlide>
    ))}
  </Swiper>
);
